module.exports = __webpack_public_path__ + "img/Hand_31_05_26.a03933be.png";